const BASE_URL = process.env.REACT_APP_URL_INFO;

function buildUrl(path, params) {
    const url = new URL(`${BASE_URL}${path}`, window.location.origin);
    if (params) {
        Object.entries(params).forEach(([k, v]) => {
            if (v == null || v === '' || v === 'All') return;
            url.searchParams.set(k, String(v));
        });
    }
    return url.toString();
}

async function request(method, path, { params, body, headers, etag } = {}) {
    const url = buildUrl(path, params);
    const res = await fetch(url, {
        method,
        headers: {
            'Content-Type': 'application/json',
            ...(etag ? { 'If-None-Match': etag } : null),
            ...headers,
        },
        body: body ? JSON.stringify(body) : undefined,
    });

    if (res.status === 304) return { status: 304, data: null, etag: etag ?? null };

    const et = res.headers.get('ETag') || null;
    if (!res.ok) {
        let detail = '';
        try { detail = (await res.json())?.detail || ''; } catch { }
        throw new Error(detail || `${res.status} ${res.statusText}`);
    }

    const data = await res.json().catch(() => null);
    return { status: res.status, data, etag: et };
}

export const http = {
    get: (p, o) => request('GET', p, o),
    post: (p, o) => request('POST', p, o),
    put: (p, o) => request('PUT', p, o),
    patch: (p, o) => request('PATCH', p, o),
    delete: (p, o) => request('DELETE', p, o),
};
